import { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { Box, ListItem, UnorderedList } from '@cdl/heartbeat-react';
import { InfoModal } from './InfoModal';
import {
  annotationTaskSelector,
  previousAnnotationTaskSelector,
} from '../selectors/annotation-task.selectors';
import { preferencesSelector } from '../../auth/selectors/auth.selectors';
import { useLogout } from '../../../shared/hooks/useLogout';

export const AnnotationGridChecker: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const logout = useLogout();
  const annotationTask = useSelector(annotationTaskSelector);
  const userPreferences = useSelector(preferencesSelector);
  const previousAnnotationTask = useSelector(previousAnnotationTaskSelector);
  const blockAnnotation =
    !!annotationTask &&
    previousAnnotationTask === null &&
    annotationTask.status === 'ongoing' &&
    annotationTask.annotationGrid !== userPreferences?.annotationTable;
  return (
    <>
      {children}
      <InfoModal
        isBlocking={true}
        title='Warning'
        onClose={logout}
        isOpen={blockAnnotation}
        closeButtonLabel='Disconnect'
      >
        <Box as='p' mb='m'>
          The annotation task has a different annotation table than the one set
          on your user. You can't continue to annotate.
        </Box>
        <Box as='p' mb='m' fontWeight={600}>
          Please disconnect and contact the platform administrator with the
          following information:
        </Box>
        <UnorderedList>
          <ListItem>
            Task annotation table: <b>{annotationTask?.annotationGrid}</b>
          </ListItem>
          <ListItem>
            User annotation table: <b>{userPreferences?.annotationTable}</b>
          </ListItem>
        </UnorderedList>
      </InfoModal>
    </>
  );
};
